<template>
    <div>
        <div class="p-6 mb-15 shadow-md rounded-md">
            <div class="grid md:grid-cols-2 xl:grid-cols-4 gap-3 gap-y-4">
                <label class="block">
                    <span class="block text-lg font-semibold leading-6 mb-2">Select survey template</span>
                    <jet-select
                        v-model:selected="selectedTemplate"
                    >
                        <option :value="null">-</option>
                        <option v-for="(templateName, templateId) in surveyTemplates"
                                :key="'surveyTemplate-' + templateId"
                                :value="templateId"

                        >
                            {{ templateName }}
                        </option>
                    </jet-select>
                </label>
                <label class="block">
                    <span class="block text-lg font-semibold leading-6 mb-2">Select organization</span>
                    <jet-select
                        v-model:selected="selectedOrg"
                    >
                        <option :value="null">-</option>
                        <option v-for="(orgName, orgId) in organizations"
                                :key="'org-' + orgId"
                                :value="orgId"

                        >
                            {{ orgName }}
                        </option>
                    </jet-select>
                </label>
                <label class="block">
                    <span class="block text-lg font-semibold leading-6 mb-2">From</span>
                    <jet-input type="date"
                               v-model="startDateValue"
                               @change.prevent="filterScores"
                               class="block w-full mt-1 text-sm">
                    </jet-input>
                </label>
                <label class="block">
                    <span class="block text-lg font-semibold leading-6 mb-2">To</span>
                    <jet-input type="date"
                               v-model="endDateValue"
                               @change.prevent="filterScores"
                               class="block w-full mt-1 text-sm">
                    </jet-input>
                </label>
            </div>
        </div>
        <template-survey-scores-explorer v-if="isSuperAdmin && selectedTemplate && templateScores"
                                         :paginated-template-scores="templateScores"
                                         :loading="loading"
                                         @start-visit="isLoading"
                                         @finish-visit="isNotLoading"
        />
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import {usePage} from "@inertiajs/inertia-vue3";
import TemplateSurveyScoresExplorer from "@/Components/TemplateSurveyScoresExplorer";
import JetInput from "@/Jetstream/Input";
import JetSelect from "@/Jetstream/Select";
import {ref, watch} from "vue";
import {Inertia} from "@inertiajs/inertia";
import TablePagination from "@/Jetstream/TablePagination";
import DashboardHeaderSlot from "@/Components/DashboardHeaderSlot";

export default {
    name: 'DashboardTemplateScoresExplorer',
    components: {
        TablePagination,
        TemplateSurveyScoresExplorer,
        JetInput,
        JetSelect,
    },
    layout: (h, page) => {
        return h(AppLayout, {
            title: "Dashboard",
        }, {
            header: () => h(DashboardHeaderSlot, {
                name: usePage().props.value.user.name
            }),
            default: () => page,
        });
    },
    setup() {
        const {
            surveyTemplates,
            organizations,
            templateScores,
            startDate,
            endDate,
            templateId,
            orgId,
        } = usePage().props.value;

        const tenant = usePage().props.value.tenant;

        const isSuperAdmin = usePage().props.value.user?.roles.some((role) => role.name === "Super Admin");

        const startDateValue = ref(startDate);
        const endDateValue = ref(endDate);
        const selectedTemplate = ref(templateId)
        const selectedOrg = ref(orgId)

        const loading = ref(false);

        const filterScores = () => {
            isLoading()
            Inertia.visit(route('admin.dashboard.template-survey-scores', {
                startDate: startDateValue.value,
                endDate: endDateValue.value,
                templateId: selectedTemplate.value,
                orgId: selectedOrg.value,
            }, {
                method: 'get',
                preserveScroll: true,
            }));
        };

        watch(selectedTemplate, filterScores)
        watch(selectedOrg, filterScores)

        const isLoading = () => {
            loading.value = true;
        }

        const isNotLoading = () => {
            loading.value = false;
        }

        return {
            startDateValue,
            endDateValue,
            surveyTemplates,
            organizations,
            templateScores,
            tenant,
            isSuperAdmin,
            selectedTemplate,
            selectedOrg,
            loading,
            isLoading,
            isNotLoading,
            filterScores
        }
    }
}
</script>
